<div>
  <div class="modal-body">
    <div class="row">
      <div class="col-2 pt-2">
        <div><label>Current sales person:</label></div>
      </div>
      <div class="col-3 pt-2 mx-2">{{ currentSalesPerson }}</div>
      <div class="col-2 pt-2"><label>New sales person:</label></div>
      <div class="col-3 pt-2 mx-2">
        <ng-select placeholder="Select Salesperson" (change)="handleSelectedUser($event)" style="width: 100%">
          <ng-option *ngFor="let salesperson of salesPeopleList" [value]="salesperson">
            {{ salesperson.name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-flex float-end justify-content-end">
      <button class="btn btn-cancel float-right" (click)="handleCloseModel()">CANCEL</button>
      <button class="btn btn-save float-right" (click)="updateSalsePerson()" [disabled]="!formValid">UPDATE</button>
    </div>
  </div>
</div>